import React from 'react';

import { useFormContext } from 'react-hook-form';

import { z } from 'zod';

import { FormControl, FormField, FormItem, FormMessage } from 'components/ui';

import { templateStudioSchema } from '../../../validation-schema';
import { TemplateStudioOfferPerRowSelect } from '../Components/OfferPerRowSelect';
import { ThemesFormItem } from '../Components/ThemesFormItem';

export const TemplateStudioBundleForm: React.FC = () => {
  const { control } = useFormContext<z.infer<typeof templateStudioSchema>>();

  return (
    <>
      <FormField
        control={control}
        name="bundle.themes"
        render={({ field }) => (
          <ThemesFormItem onChange={field.onChange} value={field.value || []} />
        )}
      />
      <FormField
        control={control}
        name="bundle.offersPerRow"
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <TemplateStudioOfferPerRowSelect
                value={field.value}
                onChange={field.onChange}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};
